import React from 'react';

export function ChevronUpAndDown () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="none"
      viewBox="0 0 13 13"
    >
      <path
        fill="#000"
        d="M8.754 8.017a.375.375 0 010 .53l-2.25 2.25a.373.373 0 01-.531 0l-2.25-2.25a.375.375 0 01.53-.53l1.985 1.985 1.985-1.985a.375.375 0 01.53 0zm-4.5-3.97l1.984-1.984 1.985 1.985a.375.375 0 10.53-.53l-2.25-2.25a.375.375 0 00-.53 0l-2.25 2.25a.375.375 0 00.53.53z"
      />
    </svg>
  );
}
